import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Purchases/MaterialRequest/tables";
import headers from "../../../../Data/Tables/Purchases/MaterialRequest/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_material_requests } from "../../../../Controllers/Purchases/MaterialRequests";

const MaterialRequestTable = () => {
    const [loader, setLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [body, setBody] = useState();

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
    });

    const paginationdata = (data) => {
        let headerdata = {};
        header?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
        });
    };

    const formdata = (data) => {
        let page = data?.search ? pagination?.currentPage : 1;
        fetchData({
            ...data,
            currentPage: page,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const actiondata = (data) => {
        let headerdata = {};
        headers?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
            currentPage: pagination?.currentPage,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const params = {
                search: tabledata?.search,
                sort: tabledata?.sort,
                status: tabledata?.status,
                request_status: tabledata?.request_status,
                priority: tabledata?.priority,
                page: tabledata?.currentPage,
            };

            const result = await get_all_material_requests(params);

            if (result?.status) {
                let data = [];

                result?.data?.data?.map((value) => {
                    data.push({
                        path: `/app/purchases/mrn/view/${value?._id}`,
                        Number: value?.number,
                        Date: value?.date
                            ? new Date(value?.date).toLocaleDateString()
                            : "—",
                        Site: value?.site?.name || "—",
                        "Requested By": value?.requested_by?.name || "—",
                        Priority: (
                            <span
                                className={`px-2 py-1 rounded-full text-xs font-medium ${value?.priority === 1
                                    ? "bg-red-100 text-red-600"
                                    : "bg-gray-100 text-gray-600"
                                    }`}
                            >
                                {value?.priority === 1 ? "Urgent" : "Normal"}
                            </span>
                        ),
                        Status: <RequestStatus status={value?.request_status} />,
                        Action: (
                            <ActionButton
                                edit={`/app/purchases/mrn/edit/${value?._id}`}
                                id={value?._id}
                                api="delete-material-request"
                                actiondata={actiondata}
                                headers={header}
                            />
                        ),
                    });
                });

                setPagination({
                    currentPage: result?.data?.currentPage,
                    totalCount: result?.data?.totalCount,
                    totalPages: result?.data?.totalPages,
                });

                setBody(data);
                setLoader(false);
            } else {
                toast?.error(result?.message);
                setLoader(false);
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    const headerReset = () => {
        let componentData = [];
        headers?.components?.map((value) => {
            componentData.push({ ...value, value: null });
        });
        setHeader({ ...headers, components: componentData });
    };

    useEffect(() => {
        fetchData();
        headerReset();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Table
                    head={tables}
                    body={body}
                    pagination={pagination}
                    paginationdata={paginationdata}
                />
            </Loadercomponent>
        </Header>
    );
};

// Request status badge component
const RequestStatus = ({ status }) => {
    const map = {
        0: { label: "Draft", class: "bg-gray-100 text-gray-600" },
        1: { label: "Submitted", class: "bg-blue-100 text-blue-600" },
        2: { label: "Processing", class: "bg-yellow-100 text-yellow-600" },
        3: { label: "Partially Fulfilled", class: "bg-orange-100 text-orange-600" },
        4: { label: "Fully Fulfilled", class: "bg-green-100 text-green-600" },
        5: { label: "Closed", class: "bg-purple-100 text-purple-600" },
        6: { label: "Cancelled", class: "bg-red-100 text-red-600" },
    };

    const current = map[status] || map[0];

    return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${current.class}`}>
            {current.label}
        </span>
    );
};

export default MaterialRequestTable;